import React from 'react';
import GroupLabel from '../GroupLabel/GroupLabel';
import Option from '../Option/Option';
import styles from './Options.module.scss';

const Options = ({ options }) => {
  return (
    <ul className={styles.root}>
      {options.map((option, index) => (
        <li key={option.key || index}>
          {option.label ? (
            <GroupLabel option={option} />
          ) : (
            <Option option={option} />
          )}
        </li>
      ))}
    </ul>
  );
};

export default Options;
